module.exports = __webpack_public_path__ + "img/rep-claudia.e0a8c58f.png";